<div id="shift-export" #shiftExport>
  <c-card *transloco="let t">
    <c-card-body *ngIf="shift">
        <c-container class="px-2">
            <c-row>
              <c-col md="6">
                <div class="card-header">
                  <h5>
                    {{shift.name}}
                  </h5>
                </div>
              </c-col>
              <c-col md="6" class="text-end" data-html2canvas-ignore>
                <div class="btn-group" role="group" aria-label="Basic example">

                      <button color="light" cButton class="my-2" (click)="getShift()">
                        <i class="fa-solid fa-arrows-rotate"></i> {{ t('Refresh') }}
                    </button>
                    <button color="success" cButton class="my-2" (click)="exportShift()">
                      {{ t('Export Shift as PDF') }}
                    </button>
                    <button color="light" cButton class="me-1 my-2" routerLink="/mgmt/shifts/shifts">
                        <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                        {{ t('Return to Shifts') }}
                    </button>
                </div>

              </c-col>

            </c-row>
            <div class="row">
              <div class="col-md-6 col-sm-8">
                <table
                [hover]="true"
                [responsive]="true"
                [striped]="true"
                align="middle"
                cTable
                class="mb-0 border"
                >
                    <tbody>
                      <tr><td class="text-right"><b>{{ t('Status') }}</b></td><td>{{shift.status}}</td></tr>
                      <tr><td class="text-right"><b>{{ t('Start') }}</b></td><td>{{shift.start}}</td></tr>
                      <tr *ngIf="shift.end"><td class="text-right"><b>{{ t('End') }}</b></td><td>{{shift.end}}</td></tr>
                      <tr><td class="text-right"><b>{{ t('Hours') }}</b></td><td>{{shift.hours}}</td></tr>
                    </tbody>
                  </table>

                  <div class="card mt-2">
                    <div class="card-body" *ngIf="shift.type=='full' || shift.type=='gps-high'">
                      {{ t("The phone's GPS is being used to provide continuous location data every 10 seconds. It is the most accurate setting and should be used if the worker needs very accurate movement monitoring.") }}
                    </div>
                    <div class="card-body" *ngIf="shift.type=='emergency' || shift.type=='battery_saver' || shift.type=='non-gps'">
                      {{ t('This setting does NOT use GPS, while this uses minimal battery the location is only approximate, this setting should not be used if an accurate location is required.') }}
                    </div>
                    <div class="card-body" *ngIf="shift.type=='gps-medium'">
                      {{ t("The phone's GPS is being used to provide continuous location data every 1-2 minutes. With this setting the battery use is minimised whilst still providing an accurate location in case of emergency.") }}
                    </div>
                    <div class="card-body" *ngIf="shift.type=='in_use' || shift.type=='in_use_only'">
                      {{ t("This worker has limited our tracking ability in the app. They do not allow tracking when the app is in the background. Therefore we have limit locations for this shift. Please ask them to set location settings to 'Always', so we can see their location in case of emergency.") }}
                    </div>
                  </div>


              </div>
              <div class="col-md-6 col-sm-8">
                <table
                [hover]="true"
                [responsive]="true"
                [striped]="true"
                align="middle"
                cTable
                class="mb-0 border"
                >

                  <tbody>


                    <tr *ngFor="let pin of shift.pins">

                      <!-- Original Geotab Data -->
                      <ng-container *ngIf="pin.status">


                      <td>
                          <i class="fas fa-map-marker-alt fa-2x"
                            [style.color]="markerColor(pin)"
                          ></i>
                      </td>



                      <td>
                        <span *ngIf="pin.status == 'ok'">{{ t('Check In at') }} </span>
                        <span *ngIf="pin.status == 'start'">{{ t('Started shift at') }} </span>
                        <span *ngIf="pin.status == 'end'">{{ t('Ended shift at') }} </span>
                        <span *ngIf="pin.status == 'help'">{{ t('Requested Help at') }} </span>
                        <span *ngIf="pin.status == 'missed'">{{ t('Missed Check In Alert Sent at') }} </span>
                        <span *ngIf="pin.status == 'mandown'">{{ t('Man Down Alert Sent at') }} </span>
                        {{ pin.created_at }}
                      </td>

                    <td>
                      <td>
                        <button type="button" class="btn btn-light" (click)="viewPin(pin)" *ngIf="pin.location">{{ t('View') }}</button>
                        <span class="badge badge-warning text-dark" *ngIf="!pin.location || pin.location.lat==0 || pin.location.lat==0">{{ t('No Location Available') }}</span>
                      </td>



                      </ng-container>

                      <!-- Main OK Alone System Data -->
                      <ng-container *ngIf="!pin.status">

                        <td>
                            <i class="fas fa-map-marker-alt fa-2x"
                              [style.color]="markerColor(pin)"
                            ></i>
                        </td>



                        <td>
                          {{ pin.title }}
                        </td>

                      <td>
                        <button type="button" class="btn btn-light" (click)="viewPin(pin)"  *ngIf="pin.lat">{{ t('View') }}</button>
                        <span class="badge badge-warning text-dark" *ngIf="!pin.lat">{{ t('No Location Available') }}</span>
                      </td>


                  </ng-container>

                </tr>

                  </tbody>
                </table>
              </div>
            </div>

          <div class="row">
            <div class="col">
            </div>
          </div>
          </c-container>

          <c-row>
            <c-col class="text-center m-3">
              <!-- <button type="button" class="btn btn-outline-primary" (click)="showEdit()">
                Edit the shift
              </button> -->
            </c-col>
            <div class="alert alert-warning" role="alert" *ngIf="shift.location_count == 0">
              {{ t('We have no locations for this shift. If the shift has just started they should appear in 5-10 minutes.') }}
            </div>

          </c-row>

          <div class="row" *ngIf="options">
            <div class="col">
              <p><b>{{ t("Drag this slider to see the worker location change over time:") }}</b><br/>
              <span *ngIf="this.step_location">Lat/Lng: {{this.step_location.lat}},{{this.step_location.lng}} {{ t("at") }} {{this.step_location.time}} </span>
              </p>
              <ngx-slider [(value)]="step" [options]="options" (userChange)="changeLocation()"></ngx-slider>
            </div>
          </div>



          <c-row class="justify-content-end pt-3">

            <c-col xs="auto" >
              <div class="form-check">
                <input class="form-check-input" type="radio" value="streets" name="streets" (click)="changeStyle('streets-v12')" [checked]="style=='streets-v12'">
                <label class="form-check-label" for="streets">
                  {{ t('Streets') }}
                </label>
              </div>
            </c-col>
            <c-col xs="auto" >
              <div class="form-check">
                <input class="form-check-input" type="radio" value="satellite" name="satellite" (click)="changeStyle('satellite-streets-v12')" [checked]="style=='satellite-streets-v12'">
                <label class="form-check-label" for="satellite">
                  {{ t('Satellite') }}
                </label>
              </div>
            </c-col>
            <c-col xs="auto" >

              <div class="form-check">
                <input class="form-check-input" type="radio" value="outdoors" name="outdoors" (click)="changeStyle('outdoors-v12')" [checked]="style=='outdoors-v12'">
                <label class="form-check-label" for="outdoors">
                  {{ t('Outdoors') }}
                </label>
              </div>
            </c-col>
            <c-col xs="auto" >

              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="outdoors" name="outdoors" (click)="togglePath()" [checked]="show_path">
                <label class="form-check-label" for="outdoors">
                  {{ t('View Path') }}
                </label>
              </div>
            </c-col>

          </c-row>


    </c-card-body>
  </c-card>

  <div id="shift_map" style="height:600px;"></div>
  <div id="menu">

  </div>
</div>